module.exports = "<div class=\"aside\" id=\"sidepageAddCard\" modal-box content>\n    <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                     hidex=\"true\"></xo-aside-header>\n    <div class=\"content\">\n\t    <ui-view></ui-view>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidepage-add-card/template.html
// module id = ./pages/xo-sidepage-add-card/template.html
// module chunks = 0